import React, { memo, forwardRef } from "react";
const SvgAlphabetM = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M8.5 12.33c0-.267.04-.48.12-.64.093-.173.2-.3.32-.38a.915.915 0 01.36-.18c.133-.04.247-.06.34-.06.093 0 .2.02.32.06.133.027.26.087.38.18.12.08.22.207.3.38.093.16.14.373.14.64v.46h.04c.107-.24.247-.467.42-.68.187-.213.4-.407.64-.58.253-.173.54-.307.86-.4.32-.107.673-.16 1.06-.16.747 0 1.367.167 1.86.5.493.333.873.773 1.14 1.32.32-.587.747-1.033 1.28-1.34.533-.32 1.16-.48 1.88-.48.627 0 1.16.113 1.6.34.453.213.82.5 1.1.86.293.36.507.773.64 1.24.133.467.2.947.2 1.44v4.84c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.908.908 0 01-.4.18c-.133.04-.247.06-.34.06-.107 0-.227-.02-.36-.06a1.065 1.065 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-4.16c0-.28-.02-.573-.06-.88a2.28 2.28 0 00-.26-.82 1.668 1.668 0 00-.56-.62c-.227-.16-.533-.24-.92-.24-.373 0-.693.08-.96.24-.267.16-.487.367-.66.62-.173.253-.3.54-.38.86-.08.307-.12.613-.12.92v4.08c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.908.908 0 01-.4.18c-.133.04-.247.06-.34.06-.107 0-.227-.02-.36-.06a1.065 1.065 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-4.64c0-.6-.147-1.093-.44-1.48-.28-.4-.727-.6-1.34-.6-.36 0-.673.08-.94.24-.267.147-.487.34-.66.58-.16.24-.287.52-.38.84-.08.307-.12.62-.12.94v4.12c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.908.908 0 01-.4.18c-.133.04-.247.06-.34.06-.107 0-.227-.02-.36-.06a1.065 1.065 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-7.36z"
      />
    </svg>
  );
});
SvgAlphabetM.displayName = "SvgAlphabetM";
const MemoForwardRef = memo(SvgAlphabetM);
export default MemoForwardRef;
